export default __webpack_public_path__ + "static/media/BCA29.72b3201f.jpg";